<template>
  <!-- 管线图层 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编号">
              <a-input v-model="query.classNo" placeholder="支持开始编号与结束编号查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="支持开始物探点与连接编号查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="文档名称">
              <a-select placeholder="请选择文档名称" v-model="query.batchNo" allow-clear>
                <a-select-option v-for="(item, index) in pipeLineMaterialOptions" :key="index" :value="item"
                  >{{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="检查类型">
              <a-select placeholder="请选择检查类型" v-model="query.checkType" allow-clear>
                <a-select-option v-for="(item, index) in pipeLineCheckTypeOptions" :key="index" :value="item"
                  >{{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="loadData">查询</a-button>
            </a-form-item>
            <a-form-item>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" :loading="exportLoading" style="margin-left: 8px" @click="exportHandle" v-action:export>导出</a-button>
            </a-form-item>
            <a-button type="primary" style="margin-left: 8px" @click="importHandle" v-action:import>
              <a-icon type="upload" />导入
            </a-button>
            <a-button type="primary"
                      icon="hdd"
                      style="margin-left: 8px"
                      @click="recycleBinVisible = true"
                     >回收站</a-button>
            <a-button type="danger"
                      style="margin-left: 8px"
                      @click="handleClearAll"
                     >一键清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-alert type="info" showIcon style="margin-bottom: 16px; margin-top: 16px">
      <template slot="message">
        <span>已选择</span>
        <a style="font-weight: 600; padding: 0 4px">{{ selectedRowKeys.length }}</a>
        <span>项</span>
        <template v-if="selectedRowKeys.length > 0">
          <a-divider type="vertical" />
          <a @click="handleClearSelection">清空选择</a>
          <!-- <a @click="exportHandle">导出</a> -->
          <a-divider type="vertical" />
          <a @click="handleIgnoreBatch">批量忽略</a>
          <a-divider type="vertical" />
          <a @click="handleProcessedBatch">标记处理</a>
          <a-divider type="vertical" />
          <a @click="handleDeleteBatch">批量删除</a>
        </template>
      </template>
    </a-alert>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :loading="loading"
      :dataSource="dataSource"
      :pagination="pagination"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :rowSelection="{ selectedRowKeys, onChange: handleTableSelectChange }"
      @change="pageChange"
    >
      <span slot="status" slot-scope="text, record">
        <a-tag v-if="record.status === 1" color="rgb(255, 99, 71)">未处理</a-tag>
        <a-tag v-if="record.status === 2" color="#1890ff">忽略</a-tag>
        <a-tag v-if="record.status === 3" color="rgb(50, 205, 50)">已处理</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleIgnore([record.id])"> <a-icon type="info" />忽略 </a>
        <a-divider type="vertical" />
        <a @click="handleProcessed([record.id])"> <a-icon type="check" />处理 </a>
      </span>
    </a-table>
    <importModalNotZone
      ref="importModalNotZone"
      exportUrl="/pipe-network/gis/pipe-line/data-check/check/line/import"
      @close="close"
      @loadData="loadData"
      @listPipeLineMaterialOptions="listPipeLineMaterialOptions"
      @listPipeLineCheckTypeOptions="listPipeLineCheckTypeOptions"
    ></importModalNotZone>
    <LineCheckRecycleBinModal :visible.sync="recycleBinVisible" @ok="modalFormOk" />
  </a-card>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import importModalNotZone from './module/ImportModalNotZone'
import { listByGroupBatchNo } from '@/api/manage'
import LineCheckRecycleBinModal from './module/LineCheckRecycleBinModal'

export default {
  components: { importModalNotZone, LineCheckRecycleBinModal },
  // mixins: [mixinViewModule],
  name: 'PointCheck',
  data() {
    return {
      exportLoading: false,
      recycleBinVisible: false,
      title: '管线数据检查',
      // loading: false,
      // innerVisible: false,
      selectedRowKeys: [],
      dataSource: [],
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeLineCheckTypeOptions: [],
      query: {
        classNo: '',
        geophysicalPointNumber: '',
        stateType: 1,
      },
      columns: [
        {
          title: '开始分类编码',
          dataIndex: 'startClassNo',
        },
        {
          title: '结束分类编码',
          dataIndex: 'eneClassNo',
        },
        {
          title: '物探点号',
          dataIndex: 'startGeophysicalPointNumber',
        },
        {
          title: '连接点号',
          dataIndex: 'endGeophysicalPointNumber',
        },
        {
          title: '处理状态',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '检查类型',
          dataIndex: 'checkType',
        },
        {
          title: '修复建议',
          dataIndex: 'fixMessage',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
        { title: '操作', align: 'center', dataIndex: 'action', width: 200, scopedSlots: { customRender: 'action' } },
      ],
      url: {
        // 回收站操作，get = 获取列表；put = 取回；delete = 彻底删除
        queryList: '/pipe-network/gis/pipe-line/data-check/page',
        batchIgnores: '/pipe-network/gis/pipe-line/data-check/status-ignores',
        batchProcessed: '/pipe-network/gis/pipe-line/data-check/status-processed',
        batchDelete: '/pipe-network/gis/pipe-line/data-check/batch-delete-line',
        clearAll: '/pipe-network/gis/pipe-line/data-check/clear-all-line'
      },
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/gis/pipe-line/data-check/export',
      exportFileName: '管线数据检查.xlsx',
      uploadHeader: {
        Authorization: storage.get(ACCESS_TOKEN),
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
    }
  },
  created() {
    this.getZoneData()
    this.loadData()
    this.listPipeLineMaterialOptions()
    this.listPipeLineCheckTypeOptions()
  },
  methods: {
    close() {},
    pageChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        stateType: 1,
        ...this.query,
      }
      this.$http
        .get(this.url.queryList, {
          params,
        })
        .then(({ data }) => {
          this.pagination.total = data.total ? parseInt(data.total) : 0
          this.dataSource = data.list
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRowKeys = []
      this.loadData()
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    listPipeLineMaterialOptions() {
      listByGroupBatchNo('batch_no', 1).then(({ data }) => {
        this.pipeLineMaterialOptions = data
      })
    },
    listPipeLineCheckTypeOptions() {
      listByGroupBatchNo('check_type', 1).then(({ data }) => {
        this.pipeLineCheckTypeOptions = data
      })
    },
    // 导出
    exportHandle() {
      this.exportLoading = true
      const params = {
        responseType: 'arraybuffer',
        params: {
          // page: this.pagination.current,
          // limit: this.pagination.pageSize,
          ...this.query,
          stateType: 1,
        },
        headers: this.uploadHeader,
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
          this.selectedRowKeys = []
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // 导入
    importHandle() {
      this.$nextTick(() => {
        this.$refs.importModalNotZone.show()
      })
    },
    handleOk() {
      this.loadData()
      this.$emit('ok')
    },
    handleCancel() {
      this.innerVisible = false
    },
    // 忽略处理
    handleIgnore(userIds) {
      this.$confirm({
        title: '忽略处理',
        content: `您确定要忽略处理 ${userIds.length} 条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put(this.url.batchIgnores, [...userIds]).then((res) => {
            if (res.code === 0) {
              this.handleOk()
              this.handleClearSelection()
              this.$message.success(`忽略处理 ${userIds.length} 条数据成功！`)
            }
          })
        },
      })
    },
    // 标记处理
    handleProcessed(userIds) {
      this.$confirm({
        title: '标记处理',
        content: (
          <div>
            <p>您确定要标记处理这 {userIds.length} 个数据吗？</p>
          </div>
        ),
        centered: true,
        onOk: () => {
          var that = this
          // eslint-disable-next-line no-unused-vars
          const params = {
            idList: userIds,
          }
          this.$http.put(that.url.batchProcessed, [...userIds]).then((res) => {
            
            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success(`标记处理 ${userIds.length} 条数据成功！`)
            } else {
              that.$message.warning(res.message)
            }
          })
        },
      })
    },
    handleIgnoreBatch() {
      this.handleIgnore(this.selectedRowKeys)
    },
    handleProcessedBatch() {
      this.handleProcessed(this.selectedRowKeys)
    },
    handleDeleteBatch() {
      this.handleDelete(this.selectedRowKeys)
    },
    // 一键清空管线数据
    handleClearAll() {
      this.$confirm({
        title: '一键清空',
        content: '您确定要根据当前查询条件清空所有管线检查数据吗？此操作不可恢复！',
        centered: true,
        onOk: () => {
          this.$http.delete(this.url.clearAll, { params: { ...this.query, stateType: 1 } }).then((res) => {
            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success('数据已清空')
            } else {
              this.$message.error(res.message || '清空失败')
            }
          })
        },
      })
    },
    modalFormOk() {
      this.selectedRowKeys = []
      this.selectionRows = []
      this.loadData()
    },
    handleDelete(userIds) {
      this.$confirm({
        title: '批量删除',
        content: (
          <div>
            <p>您确定要批量删除这 {userIds.length} 个数据吗？</p>
          </div>
        ),
        centered: true,
        onOk: () => {
          var that = this
          // eslint-disable-next-line no-unused-vars
          const params = {
            idList: userIds,
          }
          this.$http.delete(that.url.batchDelete, { data: userIds }).then((res) => {
            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success(`批量删除 ${userIds.length} 条数据成功！`)
            } else {
              that.$message.warning(res.message)
              this.loadData()
              this.handleClearSelection()
            }
          })
        },
      })
    },
    handleClearSelection() {
      this.handleTableSelectChange([], [])
    },
    handleTableSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
